module.exports = __webpack_public_path__ + "img/report.37cc30ba.png";